import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-manually-select-contacts',
    templateUrl: './manually-select-contacts.component.html',
    styleUrls: ['./manually-select-contacts.component.scss']
})

export class ManuallySelectContactsComponent implements OnInit {
  ngOnInit(): void {
  }
}
